import React, { Component, PropTypes } from 'react'
import { Row, Col } from 'antd'
import { cooperationTypeName, templateTypeName, checkFlagTypeName, contractTypeDirectionName, payTypeName,stampOrderName } from '../../../../config/workflow/contract';

export default class ContractInfo extends Component {
  render() {
    const { data } = this.props;
    return (
      <Row style={{ marginBottom: 20, width: 1000 }}>
        <Col span={8}>
          <div className="contract-info">
            <Row>
              <Col span={5}><b>合同名称:</b></Col>
              <Col span={19}>{data.contractName}</Col>
            </Row>
            <Row>
              <Col span={5}><b>合同类型:</b></Col>
              <Col span={19}>{data.contractType && data.contractType.typeName}</Col>
            </Row>
            <Row>
              <Col span={5}><b>合同金额:</b></Col>
              <Col span={19}>￥{data.contractAmount}</Col>
            </Row>
            <Row>
              <Col span={5}><b>我方单位:</b></Col>
              <Col span={19}>{data.ourUnitName}</Col>
            </Row>
            <Row>
              <Col span={5}><b>我方对接人:</b></Col>
              <Col span={19}>{data.saleUser}</Col>
            </Row>
            <Row>
              <Col span={5}><b>开始日期:</b></Col>
              <Col span={19}>{data.startDate}</Col>
            </Row>
            <Row>
              <Col span={5}><b>盖章顺序:</b></Col>
              <Col span={18}>{data.stampOrder ? stampOrderName(data.stampOrder) : '-'}</Col>
            </Row>
          </div>
        </Col>
        <Col span={8}>
          <div className="contract-info">
            <Row>
              <Col span={5}><b>项目名称:</b></Col>
              <Col span={19}>{data.projectTitle}</Col>
            </Row>
            <Row>
              <Col span={5}><b>收支方向:</b></Col>
              <Col span={19}>{data.contractType && contractTypeDirectionName(data.contractType.direction)}</Col>
            </Row>
            <Row>
              <Col span={5}><b>预估金额:</b></Col>
              <Col span={19}>￥{data.expectedAmount}</Col>
            </Row>
            <Row>
              <Col span={5}><b>对方单位:</b></Col>
              <Col span={19}>{data.otherUnitCharge}</Col>
            </Row>
            <Row>
              <Col span={5}><b>模板类型:</b></Col>
              <Col span={19}>{templateTypeName(data.templateType)}</Col>
            </Row>
            <Row>
              <Col span={5}><b>结束日期:</b></Col>
              <Col span={19}>{data.endDate}</Col>
            </Row>
            <Row>
              <Col span={5}><b>一式几份:</b></Col>
              <Col span={19}>{data.copyNum ? data.copyNum : '-'}</Col>
            </Row>
          </div>
        </Col>
        <Col span={8}>
          <div className="contract-info">
            <Row>
              <Col span={5}><b>合同描述:</b></Col>
              <Col span={19}>{data.contentDesc}</Col>
            </Row>
            <Row>
              <Col span={5}><b>付款方式:</b></Col>
              <Col span={19}>{data.payType && payTypeName(data.payType)}</Col>
            </Row>
            <Row>
              <Col span={5}><b>合作类型:</b></Col>
              <Col span={19}>{cooperationTypeName(data.cooperationType)}</Col>
            </Row>
            <Row>
              <Col span={5}><b>对方对接人:</b></Col>
              <Col span={19}>{data.otherUnitCharge}</Col>
            </Row>
            <Row>
              <Col span={5}><b>账期:</b></Col>
              <Col span={19}>{data.accountPeriod}</Col>
            </Row>
            <Row>
              <Col span={5}><b>审核状态:</b></Col>
              <Col span={18}>{checkFlagTypeName(data.checkFlag)}</Col>
            </Row>
          </div>
        </Col>
      </Row>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/workflow/assigneeDetail/contract/contractInfo.js